import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { UtilityService } from 'app/services/utility.service';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	constructor(private toastr: ToastrService, private utilityService: UtilityService) {}

	showSuccess(message, title: string = '') {
		this.toastr.success(message, title);
	}

	showError(message, title: string = 'Error', override?: Partial<IndividualConfig>) {
		this.toastr.error(this.utilityService.getErrorMessage(message), title, override);
	}

	showInfo(message, title = '') {
		this.toastr.info(message, title);
	}

	showWarning(message, title) {
		this.toastr.warning(message, title);
	}
}
